import { FC } from 'react'
import { Button2 } from '@/componentsV2/atoms/Button2'
import { sanitizeUrl } from '@/utils'
import styles from './index.module.scss'

export const SubsidyFAQInquiryContent: FC = () => {
  return (
    <div className={styles.content}>
      <img src='/images/common/avatar-group.svg' alt='Avatar Group' className={styles.image} />
      <div className={styles.header}>
        <h3 className={styles.title}>まだ質問がありますか？</h3>
        <p className={styles.subText}>
          お探しの答えが見つからない場合は、どうぞお気軽に私たちのチームにお尋ねください。
        </p>
      </div>
      <div className={styles.btn}>
        <Button2
          componentType='a'
          anchorTarget='_blank'
          href={sanitizeUrl(process.env.NEXT_PUBLIC_CONTACT_SALES_JA_URL)}
          size='xl'
        >
          お問い合わせ
        </Button2>
      </div>
    </div>
  )
}
